(function() {
  "use strict";
  
  var differencesData = {
    shingleback: [
      {
        icon: "🏆",
        title: "Unbeatable Value for Money",
        text: "JB Racks offers exceptional value at $800-$1,199 compared to Shingleback's $2,100 starting price. That's a saving of $900-$1,300 while still getting a quality Australian-made rack. Both brands deliver reliable performance, but JB Racks makes vertical bike racks accessible to more families. The recent sale price of $800 represents incredible value for families already invested in bikes and cycling gear."
      },
      {
        icon: "🇦🇺",
        title: "Australian Made & Designed",
        text: "Both JB Racks and Shingleback are proudly Australian made. JB Racks is manufactured in South Australia by founder Jameson Broadbent, while Shingleback operates from North East Victoria as a family-owned business. You're supporting Australian engineering either way—the difference is in the price point and approach. JB Racks started as a high school engineering project in 2020 and has grown into a trusted brand supporting Australian cyclists."
      },
      {
        icon: "⚡",
        title: "Lightweight Yet Durable",
        text: "At just 26kg for a 4-bike model, JB Racks is significantly lighter than Shingleback's 34.9kg (5-bike Sport model). This 8.9kg difference makes mounting and removing the rack much easier, especially for solo users. Lighter doesn't mean weaker—JB Racks underwent re-engineering in October with reinforced materials for durability and stability. The lighter weight means you'll actually use your rack more often because it's not a two-person job to install."
      },
      {
        icon: "🔧",
        title: "Improved Design Based on Customer Feedback",
        text: "JB Racks has continuously improved based on customer feedback. Recent upgrades include thick rubber straps replacing the earlier securing system, anti-wobble hitch brackets now included with every purchase, and the optional slow-fold damper system for easier loading. The brand listens to real Australian riders and implements practical improvements. This agile, customer-focused approach ensures the product evolves with actual use cases."
      }
    ],
    
    velocirax: [
      {
        icon: "🏆",
        title: "Unbeatable Value for Money",
        text: "JB Racks offers Australian-made quality starting at $800 compared to VelociRAX's $799+ starting price. While prices are similar, JB Racks is manufactured locally in South Australia and weighs significantly less (26kg vs 38-43kg), making it easier to handle. You get comparable functionality with the home-grown advantage. The weight savings alone make JB Racks worth considering—mounting your rack shouldn't require a gym membership!"
      },
      {
        icon: "🇦🇺",
        title: "Australian Made & Designed",
        text: "JB Racks is 100% Australian designed and manufactured in South Australia. VelociRAX is a Utah-based American company that ships from Melbourne but manufactures in China. If supporting local Australian engineering matters to you, JB Racks is the clear choice. When you buy JB Racks, you're supporting Australian jobs, innovation, and a founder who understands what Aussie riders need."
      },
      {
        icon: "⚡",
        title: "Lightweight Yet Durable",
        text: "This is where JB Racks truly shines. At 26kg for a 4-bike model, it's dramatically lighter than VelociRAX's hefty 85-94 lbs (38-43kg) for similar capacity. That's a massive 12-17kg difference! Mounting and removing your rack becomes a one-person job instead of requiring assistance. The lighter weight doesn't compromise strength—recent re-engineering focused on reinforced materials that provide excellent durability without unnecessary bulk."
      },
      {
        icon: "🔧",
        title: "Improved Design Based on Customer Feedback",
        text: "JB Racks evolved from direct customer feedback with recent upgrades including reinforced materials, thick rubber straps for better security, anti-wobble brackets as standard, and the optional slow-fold damper. The brand is agile and responsive, constantly improving based on what Australian riders actually need. This isn't a corporate product line—it's gear made by riders, for riders, refined through real-world testing on Australian roads."
      }
    ],
    
    thule: [
      {
        icon: "🏆",
        title: "Unbeatable Value for Money",
        text: "JB Racks at $800-$1,199 represents incredible value compared to Thule's $1,450+ price tags. That's a $300-$650 saving! While Thule is a premium global brand with extensive marketing, JB Racks delivers the core functionality Australian families need without the premium brand markup. Perfect for riders who want quality without overpaying. Invest the savings in better bikes, gear, or more riding adventures!"
      },
      {
        icon: "🇦🇺",
        title: "Australian Made & Designed",
        text: "JB Racks is proudly Australian-made in South Australia, supporting local manufacturing and jobs. Thule is a premium Swedish brand with global distribution and international marketing budgets. When you buy JB Racks, you're investing in Australian innovation and can contact the founder directly for support. No call centers, no overseas customer service—just direct access to the people who build your rack."
      },
      {
        icon: "⚡",
        title: "Lightweight Yet Durable",
        text: "At 26kg for a 4-bike rack, JB Racks is easier to handle than many premium alternatives. The lighter weight doesn't compromise strength—recent re-engineering focused on reinforced materials that provide durability without excess bulk. Easy mounting means you'll actually use your rack more often. Why struggle with a heavy rack when a lighter option performs just as well? JB Racks proves you don't need excessive weight for excellent performance."
      },
      {
        icon: "🔧",
        title: "Improved Design Based on Customer Feedback",
        text: "JB Racks continuously evolves based on real Australian rider feedback. The October upgrade added reinforced materials, improved rubber straps, and anti-wobble brackets as standard. This agile approach means the product keeps getting better based on actual user experience, not just lab testing. While global brands move slowly with annual model updates, JB Racks can implement improvements quickly based on what works on Australian roads."
      }
    ],
    
    atlantis: [
      {
        icon: "🏆",
        title: "Unbeatable Value for Money",
        text: "JB Racks provides transparent pricing at $800-$1,199 with clear specifications. You know exactly what you're getting before you buy. The recent sale price of $800 for a 4-bike rack represents exceptional value for Australian families. Transparent pricing means no surprises, no contact us for quote runaround—just straightforward value. Order online, know your cost, and get it delivered. Simple."
      },
      {
        icon: "🇦🇺",
        title: "Australian Made & Designed",
        text: "Both JB Racks and Atlantis are Australian-made products supporting local manufacturing. JB Racks is manufactured in South Australia by founder Jameson Broadbent, who started the company as a high school engineering project in 2020. It's a true homegrown success story you can be proud to support. From classroom concept to trusted brand, JB Racks represents the best of Australian innovation and determination."
      },
      {
        icon: "⚡",
        title: "Lightweight Yet Durable",
        text: "At 26kg for a 4-bike model, JB Racks is notably lighter than many competitors. This significant weight reduction makes mounting and removing the rack a one-person job. You'll appreciate this every time you need to take the rack on or off your vehicle—no more calling for backup just to install your bike rack. The weight savings also means less stress on your hitch and better fuel economy."
      },
      {
        icon: "🔧",
        title: "Improved Design Based on Customer Feedback",
        text: "JB Racks has a proven track record of listening to customers and implementing improvements. The October enhancement included reinforced materials for greater durability and stability, upgraded thick rubber straps for better security, and anti-wobble brackets now standard. This responsive approach ensures the product evolves with real-world use. When customers speak, JB Racks listens—and acts quickly to make improvements that matter."
      }
    ]
  };
  
  function renderDifferences() {
    var pageHandle = window.location.pathname.split("/").pop();
    var competitor = pageHandle.split("-vs-")[1] || "";
    var data = differencesData[competitor];
    
    if (!data) {
      console.log("No differences data found for competitor:", competitor);
      return;
    }
    
    var container = document.getElementById("key-differences-content");
    if (!container) {
      console.log("Key differences container not found");
      return;
    }
    
    var html = "";
    for (var i = 0; i < data.length; i++) {
      html += '<div class="difference-item">';
      html += "<h3>" + data[i].icon + " " + data[i].title + "</h3>";
      html += "<p>" + data[i].text + "</p>";
      html += "</div>";
    }
    container.innerHTML = html;
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderDifferences);
  } else {
    renderDifferences();
  }
})();